/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AbpPtwExceptionHttpResponseModel,
  CreateOrUpdateUnitDto,
  HistoryDto,
  ODataPostProcessedResultsOfUnitDto,
  ProblemDetails,
  UnitDto,
} from '../models/index';
import {
    AbpPtwExceptionHttpResponseModelFromJSON,
    AbpPtwExceptionHttpResponseModelToJSON,
    CreateOrUpdateUnitDtoFromJSON,
    CreateOrUpdateUnitDtoToJSON,
    HistoryDtoFromJSON,
    HistoryDtoToJSON,
    ODataPostProcessedResultsOfUnitDtoFromJSON,
    ODataPostProcessedResultsOfUnitDtoToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    UnitDtoFromJSON,
    UnitDtoToJSON,
} from '../models/index';

export interface CreateUnitRequest {
    createOrUpdateUnitDto?: CreateOrUpdateUnitDto;
}

export interface DeleteUnitRequest {
    id: string;
}

export interface GetUnitRequest {
    id: string;
}

export interface GetUnitHistoryRequest {
    id: string;
}

export interface GetUnitListRequest {
    $filter?: string;
    $search?: string;
    $top?: number;
    $skip?: number;
    $orderby?: string;
}

export interface UpdateUnitRequest {
    id: string;
    createOrUpdateUnitDto?: CreateOrUpdateUnitDto;
}

export interface ValidateUnitRequest {
    createOrUpdateUnitDto?: CreateOrUpdateUnitDto;
}

/**
 * 
 */
export class UnitsApi extends runtime.BaseAPI {

    /**
     * Adds a new entity
     */
    async createUnitRaw(requestParameters: CreateUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnitDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/units`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateUnitDtoToJSON(requestParameters.createOrUpdateUnitDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => UnitDtoFromJSON(jsonValue));
    }

    /**
     * Adds a new entity
     */
    async createUnit(requestParameters: CreateUnitRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.createUnitRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<UnitDto>(response, errorHandlers);
    }

    /**
     * Deletes the entity with the given id.
     */
    async deleteUnitRaw(requestParameters: DeleteUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteUnit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/units/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes the entity with the given id.
     */
    async deleteUnit(requestParameters: DeleteUnitRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.deleteUnitRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     * Returns one entity for detail view.
     */
    async getUnitRaw(requestParameters: GetUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnitDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getUnit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/units/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => UnitDtoFromJSON(jsonValue));
    }

    /**
     * Returns one entity for detail view.
     */
    async getUnit(requestParameters: GetUnitRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getUnitRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<UnitDto>(response, errorHandlers);
    }

    /**
     */
    async getUnitHistoryRaw(requestParameters: GetUnitHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HistoryDto>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getUnitHistory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/units/{id}/history`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HistoryDtoFromJSON));
    }

    /**
     */
    async getUnitHistory(requestParameters: GetUnitHistoryRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getUnitHistoryRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<Array<HistoryDto>>(response, errorHandlers);
    }

    /**
     * Returns a list of entities for grid view.
     */
    async getUnitListRaw(requestParameters: GetUnitListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ODataPostProcessedResultsOfUnitDto>> {
        const queryParameters: any = {};

        if (requestParameters.$filter !== undefined) {
            queryParameters['$filter'] = requestParameters.$filter;
        }

        if (requestParameters.$search !== undefined) {
            queryParameters['$search'] = requestParameters.$search;
        }

        if (requestParameters.$top !== undefined) {
            queryParameters['$top'] = requestParameters.$top;
        }

        if (requestParameters.$skip !== undefined) {
            queryParameters['$skip'] = requestParameters.$skip;
        }

        if (requestParameters.$orderby !== undefined) {
            queryParameters['$orderby'] = requestParameters.$orderby;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/units`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfUnitDtoFromJSON(jsonValue));
    }

    /**
     * Returns a list of entities for grid view.
     */
    async getUnitList(requestParameters: GetUnitListRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getUnitListRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ODataPostProcessedResultsOfUnitDto>(response, errorHandlers);
    }

    /**
     */
    async getUnitsCatalogRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UnitDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/units/catalog`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UnitDtoFromJSON));
    }

    /**
     */
    async getUnitsCatalog(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getUnitsCatalogRaw(initOverrides);
        return this.configuration.handleFunction<Array<UnitDto>>(response, errorHandlers);
    }

    /**
     * Updates an entity, if existing
     */
    async updateUnitRaw(requestParameters: UpdateUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnitDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateUnit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/units/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateUnitDtoToJSON(requestParameters.createOrUpdateUnitDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => UnitDtoFromJSON(jsonValue));
    }

    /**
     * Updates an entity, if existing
     */
    async updateUnit(requestParameters: UpdateUnitRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.updateUnitRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<UnitDto>(response, errorHandlers);
    }

    /**
     * Validates an entity without adding or updating it.
     */
    async validateUnitRaw(requestParameters: ValidateUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/units/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateUnitDtoToJSON(requestParameters.createOrUpdateUnitDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validates an entity without adding or updating it.
     */
    async validateUnit(requestParameters: ValidateUnitRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.validateUnitRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

}
